<template>
  <div :style="styles" class="cls-asg">
    <c-asg v-if="lstItems && lstItems.asg" />
    <slot name="icon" />
    <div
      v-if="handleETC"
      class="content-text"
      v-lego-tooltip="{ value: handleTooltip, lines: onlyShowAnd ? 8 : 0, isShowHTML: true }"
    >
      <div class="ellipsis">{{ handleContent }}</div>
      <div style="padding-left: 4px">{{ handleETC }}</div>
    </div>

    <div v-show="!handleETC" class="ellipsis" v-lego-tooltip:ellipsis="`${handleContent}`">
      {{ handleContent }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipAndOther',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isShowForPeople: {
      type: Boolean,
      default: () => false
    },
    isShowUser: {
      type: Boolean,
      default: () => false
    },
    // show for tag
    onlyShowAnd: {
      type: Boolean,
      default: () => false
    },
    keyValue: {
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    lstItems: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isObjectItem() {
      return typeof this.items[0] == 'object';
    },
    handleContent() {
      if (this.isObjectItem) {
        return this.valueDefault(this.items[0][this.keyValue]);
      }
      return this.valueDefault(this.items[0]);
    },
    handleETC() {
      if (this.items.length == 1) return '';

      if (this.isShowForPeople) {
        return this.$t('label.andOtherPeople', { amount: this.items.length - 1 });
      }

      if (this.onlyShowAnd) {
        return this.$t('label.other') + ' ' + (this.items.length - 1);
      }

      if (this.isShowUser) {
        return this.$t(this.items.length === 2 ? 'label.otherOfUser' : 'label.otherOfUsers', [
          this.items.length - 1
        ]);
      }

      return this.$t('label.andOtherItems', { amount: this.items.length - 1 });
    },
    handleTooltip() {
      const numMax = 8;
      if (!this.items) return '';

      if (this.items.length && this.isObjectItem) {
        let content = [];
        this.items.forEach((i) => {
          const escapeValue = this.$util.escapeHTML(i[this.keyValue].trim());
          content.push(escapeValue);
        });
        return content.join(',</br>');
      }

      const result = this.items
        .slice(0, numMax)
        .map((item) => this.$util.escapeHTML(item))
        .join(',</br>');
      if (this.items.length > numMax) return result + ',...';

      return result;
    }
  },
  methods: {
    valueDefault(value) {
      return value || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.cls-asg {
  display: flex;
  flex-flow: nowrap;
  width: inherit;
  max-width: 100%;
}

.badge-asg {
  margin-right: 8px;
  max-width: 38px;
}

.content-text {
  display: flex;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.ellipsis {
  width: auto;
  max-width: unset;
}
</style>
